"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageFacade = void 0;
/**
 * Facade for `LocalStorageKeyStore` encapsulating the access to the actual
 * local storage
 */
var LocalStorageFacade = /** @class */ (function () {
    function LocalStorageFacade() {
        this.storage = null;
        this.prefix = "stellarkeys";
    }
    LocalStorageFacade.prototype.configure = function (params) {
        Object.assign(this, params);
    };
    LocalStorageFacade.prototype.hasKey = function (id) {
        this.check();
        return this.storage !== null
            ? this.storage.getItem("".concat(this.prefix, ":").concat(id)) !== null
            : null;
    };
    LocalStorageFacade.prototype.getKey = function (id) {
        this.check();
        var item = this.storage !== null
            ? this.storage.getItem("".concat(this.prefix, ":").concat(id))
            : null;
        return item ? JSON.parse(item) : null;
    };
    LocalStorageFacade.prototype.setKey = function (id, key) {
        this.check();
        return this.storage !== null
            ? this.storage.setItem("".concat(this.prefix, ":").concat(id), JSON.stringify(__assign({}, key)))
            : null;
    };
    LocalStorageFacade.prototype.removeKey = function (id) {
        this.check();
        return this.storage !== null
            ? this.storage.removeItem("".concat(this.prefix, ":").concat(id))
            : null;
    };
    LocalStorageFacade.prototype.getAllKeys = function () {
        this.check();
        var regexp = RegExp("^".concat(this.prefix, "\\:(.*)"));
        var keys = [];
        if (this.storage !== null) {
            for (var i = 0; i < this.storage.length; i++) {
                var raw_id = this.storage.key(i);
                if (raw_id !== null && regexp.test(raw_id)) {
                    var key = this.getKey(regexp.exec(raw_id)[1]);
                    if (key !== null) {
                        keys.push(key);
                    }
                }
            }
        }
        return keys;
    };
    LocalStorageFacade.prototype.check = function () {
        if (this.storage === null) {
            throw new Error("A storage object must have been set");
        }
        if (this.prefix === "") {
            throw new Error("A non-empty prefix must have been set");
        }
        return this.storage !== null && this.prefix !== "";
    };
    return LocalStorageFacade;
}());
exports.LocalStorageFacade = LocalStorageFacade;
